const oboardingEn = {
  errors: {
    204: 'This user already exists. The operation was cancelled',
    401: 'You invite expired. Please, contact your 4bee Work+ administrator to request a new invite',
    generic: 'It was not possible to complete this operation',
  },
};

export default oboardingEn;
